import React, {useState} from 'react';
import MyForm from './../components/Form.jsx'
import {Params} from './../params.jsx'
import SecondHead from './../components/SecondHead'
import {getNumberNights} from './../assets/number_nights'
import axios from 'axios'
import { Link } from "react-router-dom";


import {SERVER} from './../config.jsx'



const server = SERVER || 'http://localhost:5000'


function Booking(props){
    const[announcment, setAnnouncment] = useState(true)
    const[answer, setAnswer] = useState(Params(props.lang).good_reserve)
    

    const onBook = (info) => {
        const T = new Date()
        console.log('T=',T)
        setAnnouncment(false)

        const full_info = {
          status: 1,
          booking_code: 'R' + props.number + '_' + T.getTime().toString().substr(-4),
          arrival: Date.parse(props.arrival),
          arrival_for_mail: props.arrival,
          departure: Date.parse(props.departure),
          departure_for_mail: props.departure,
          salutation: info.salutation,
          name: info.name,
          phone: info.phone,
          email: info.email,
          passport: info.passport,
          number: props.number,
          lang: props.lang
        }

        const ax = axios.create({
        baseURL: `${server}/`,
        timeout: 5000,
        withCredentials: false,
        })
        ax.post('api/user/book', full_info)
          .then((response) => {
            if(response.data) setAnswer(Params(props.lang).good_reserve)
                else setAnswer(Params(props.lang).error_2)

        })
        .catch((error) => {
            console.log('error',error);

        }) 

    }

    return(

        <>
        <SecondHead lang = {props.lang} link = {props.link}/>

        <div className="container mymarge">   
            <div className="row">
                <div className="col-md-8 bg3 d-flex justify-content-center align-items-center">

                       <div className="fs-4 d-flex flex-column justify-content-center align-items-center w-100 h-100">

                                  <p>{Params(props.lang).brand}</p>
                                  <p>{Params(props.lang).apartment} {props.number} </p>
                                  <p>{Params(props.lang).price}

                                  {props.Info[props.number - 1].price} 
                                  {props.Info[0].currency}/{Params(props.lang).night}
                               
                                   </p>
                                  <p>{Params(props.lang).check_in} {Params(props.lang).arrival}: {props.arrival}</p>
                                  <p>{Params(props.lang).check_out}{Params(props.lang).departure}: {props.departure}</p>
                                  <p>{Params(props.lang).nights}{getNumberNights(props.arrival, props.departure)}</p>
                                  <p>{Params(props.lang).total}
                                  {getNumberNights(props.arrival, props.departure) * props.Info[props.number - 1].price}
                                    {props.Info[1].currency}
                                   </p>
                                  <p>{Params(props.lang).notice} {props.Info[1].tax} {props.Info[1].currency}  {Params(props.lang).for_day}</p>
            
                        </div>
            
                </div>
                <div className="col-md-4 bg3 d-flex flex-column justify-content-center">
                   <div className="fs-3 my-first-letter bg1 mx-3 mb-4 desc-room px-3 pt-3 pb-3 mt-3">
                   {
                    announcment?

                        <MyForm lang = {props.lang} onBook = {onBook}/>
                        :
                        <p>{answer}</p>

                   }

                    </div>

                </div>
           
            </div>
        <div className="row mb-3 bg3">
            
            <div className="text-center mymarge bg3">

                    <Link to="/rooms" className="btn btn-primary fs-5 bg5 mt-3 mb-3" role="button">
                      {Params(props.lang).another_choice}
                    </Link>
            </div>
        </div>
    </div>

            
        </>
        )

}

export default Booking;